export default "__VITE_ASSET__aYLHrew0__"